import PropTypes from 'prop-types'
import React from 'react'

const FieldError = ({ type, show }) => {
  // role="alert" so assistive tech announces the message when it appears,
  // matching the .field__error treatment used everywhere else
  if (show)
    return (
      <div className="error" role="alert">
        {`Invalid ${type}`}
      </div>
    )
  return null
}

FieldError.propTypes = {
  type: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired
}

export default FieldError
